import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334m0 3.334A13.333 13.333 0 0 1 33.333 20c0 4-1.666 7.5-4.5 10-2.333-2.167-5.5-3.333-8.833-3.333S13.667 27.833 11.167 30c-2.834-2.5-4.5-6-4.5-10A13.333 13.333 0 0 1 20 6.667M16.667 10a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m6.666 0a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m5.15 4.9c-.216 0-.416.05-.65.1L22.5 17.2l-.45.183c-.933-.716-2.2-.916-3.3-.466a3.32 3.32 0 0 0-1.833 4.333 3.32 3.32 0 0 0 4.333 1.833c1.1-.433 1.883-1.416 2.083-2.616l.384-.167 5.366-2.167.034-.016c.883-.35 1.266-1.317.933-2.184a1.67 1.67 0 0 0-1.567-1.033m-16.816.1a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }